import axios from "axios";
import { useState, useEffect } from "react";
import EventRow from "../components/EventRow";
import { useTranslation } from "react-i18next";

const dummyEvent = {
  beginDate: "2000-01-01T00:00:00Z",
  name: null,
  city: "ND",
  province: "ND",
  link: "http://join.endu.net",
  logoLink: "https://ftp-endu-net.s3.amazonaws.com/brand/loghi/event-logo.png",
  disciplinesIt: ["Riprova più tardi"],
  disciplinesEn: ["Try again later"],
};

const dummyEvents = {
  events: [dummyEvent, dummyEvent],
  totalEvents: 2,
};

const EventList = () => {
  const [eventList, setEventList] = useState(dummyEvents.events);
  const [unloadedEventSize, setUnloadedEventSize] = useState(0); // It's a state because it needs to change in useEffect
  const [loadedEventSize, setLoadedEventSize] = useState(50);
  const [sportList, setSportList] = useState([]);
  const [sportId, setSportId] = useState(0);

  const { t } = useTranslation();

  useEffect(() => {
    const loadPageData = async () => {
      try {
        const { data } = await axios.get(
          `${window._env_.REACT_PUBLIC_ENDPOINT}/yolosite/eventlist?limit=${loadedEventSize}&sport-id=${sportId}`
        );
        console.info("Fetched eventList {}", data);
        setEventList(data.events);
        setSportList([{ id: 0, name: "Tutti gli sport" }, ...data.sportList]);
        setUnloadedEventSize(data.totalEvents - loadedEventSize);
      } catch (error) {
        console.error(error);
      }
    };
    loadPageData();
  }, [loadedEventSize, sportId]);

  const requestMoreEvents = () => {
    const newLoadEventSize = loadedEventSize + 50;
    setLoadedEventSize(newLoadEventSize);
  };

  const changeSport = (event) => {
    setLoadedEventSize(50);
    setSportId(parseInt(event.target.value));
  };

  return (
    <>
      <div className="input-group pt-1 pb-2">
        <span className="input-group-text">
          <strong>{t("filter by sport")}: </strong>
        </span>
        <select onChange={(e) => changeSport(e)} className="form-select">
          {sportList.map((sport) => (
            <option key={sport.id} value={sport.id}>
              {t(sport.name)}
            </option>
          ))}
        </select>
      </div>
      <table cellPadding="0" cellSpacing="0" width="100%" className="list">
        <tbody>
          {eventList.map((event, index) => (
            <EventRow
              key={index}
              event={event}
              requestMoreEvents={requestMoreEvents}
            />
          ))}
        </tbody>
      </table>
      {unloadedEventSize > 0 ? (
        <button
          type="button"
          onClick={() => requestMoreEvents()}
          className="btn btn-outline mt-4"
        >
          {t("load more")} - {unloadedEventSize}
        </button>
      ) : (
        <></>
      )}
    </>
  );
};

export default EventList;
